export default {
      id: "reefer-info-1-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.svg#reefer-info-1",
      toString: function () {
        return this.url;
      }
    }